import type { FloatingBoundaryPadding } from "@faire/slate/private/floating/FloatingBoundaryContext";

type SidePadding = {
  top: number;
  right: number;
  bottom: number;
  left: number;
};

/**
 * Combines shared middleware padding with boundary-specific insets (e.g. sticky columns).
 */
export const mergeFloatingDetectOverflowPadding = (
  basePadding: number,
  boundaryPadding?: FloatingBoundaryPadding
): number | SidePadding => {
  if (boundaryPadding === undefined) {
    return basePadding;
  }

  const boundarySides = toSidePadding(boundaryPadding);

  return {
    top: Math.max(basePadding, boundarySides.top),
    right: Math.max(basePadding, boundarySides.right),
    bottom: Math.max(basePadding, boundarySides.bottom),
    left: Math.max(basePadding, boundarySides.left),
  };
};

const toSidePadding = (padding: FloatingBoundaryPadding): SidePadding => {
  if (typeof padding === "number") {
    return {
      top: padding,
      right: padding,
      bottom: padding,
      left: padding,
    };
  }

  return {
    top: padding.top ?? 0,
    right: padding.right ?? 0,
    bottom: padding.bottom ?? 0,
    left: padding.left ?? 0,
  };
};
